var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2647 1.38277C12.6594 1.21989 15.0316 1.93441 16.9379 3.39283C18.8443 4.85126 20.1545 6.95384 20.6238 9.30777C21.0683 11.5371 20.7297 13.8474 19.6722 15.8509L20.7857 19.9869C20.8697 20.2987 20.7799 20.6316 20.5505 20.8589C20.3211 21.0862 19.9874 21.173 19.6763 21.0861L15.5995 19.9484C13.6052 21.0166 11.3002 21.3698 9.07073 20.9413C6.71359 20.4884 4.60198 19.1928 3.13036 17.2966C1.65874 15.4004 0.927778 13.0332 1.07403 10.6374C1.22029 8.24164 2.23375 5.98102 3.92509 4.2779C5.61644 2.57477 7.86997 1.54565 10.2647 1.38277ZM15.8458 4.8204C14.2863 3.62731 12.3457 3.04279 10.3867 3.17603C8.42762 3.30927 6.58408 4.15117 5.20045 5.54443C3.81682 6.9377 2.98774 8.78704 2.86809 10.747C2.74845 12.7069 3.34642 14.6433 4.5503 16.1946C5.75419 17.7458 7.48163 18.8057 9.40992 19.1762C11.3382 19.5468 13.3355 19.2026 15.0286 18.2081C15.2389 18.0846 15.4904 18.0518 15.7253 18.1174L18.64 18.9308L17.8423 15.9678C17.7802 15.7372 17.8125 15.4912 17.932 15.2844C18.9148 13.5845 19.245 11.5849 18.8611 9.65921C18.4772 7.73353 17.4054 6.01348 15.8458 4.8204Z",
    fill: "#C0C0C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteComment);
export default __webpack_public_path__ + "static/media/white_comment.7289950ae8a9ae8abbe1dc4866c0e30c.svg";
export { ForwardRef as ReactComponent };